import { Component, OnInit } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';

@Component({
  selector: 'app-profile-popover',
  templateUrl: './profile-popover.component.html',
  styleUrls: ['./profile-popover.component.scss'],
})
export class ProfilePopoverComponent implements OnInit {

  get userId() { return this.authService.profile.userId; }
  
  constructor(
    private authService: AuthenticationService,
    private popoverCtrl: PopoverController,
    private navCtrl: NavController
  ) { }

  ngOnInit() {

  }

  openPage(url: string) {
    this.navCtrl.navigateRoot(url);
    this.popoverCtrl.dismiss();
  }

  logout() {
    this.authService.logout();
    this.popoverCtrl.dismiss();
    this.navCtrl.navigateRoot('/auth/login');
  }
}
